<template>
    <div class="with-margin">    
        <h1>
            <span>
                <img src="/portals/0/images/dots_GM.png" alt="" />
            </span>
        </h1>
    </div>
</template>

<style scoped>
    .with-margin {
        margin-top: 15px;
        margin-bottom: 23px;
    }
    
    * {
        font-weight: normal;
        vertical-align: middle;
    }
    h1 {
        text-align: right;
        font-size: 14pt;
        margin:0;
    }
    h1 span {
        background-color: #fff;
        padding: 15px 0px 15px 15px;
    }
    h1::after {
        display: block;
        content: "";
        border: 1px solid #eeeeee;
        margin-top: -0.5em;
    }    
</style>